export const hindiFlashcards = {
    categories: [
        {
            hi: "नमस्ते",
            rm: "Namaste",
            en: "Hello / Greetings",
        },
        {
            hi: "नमस्कार",
            rm: "Namaskar",
            en: "Hello / Greetings (formal)",
        },
        {
            hi: "आपका स्वागत है",
            rm: "Aapka swagat hai",
            en: "Welcome",
        },
        {
            hi: "धन्यवाद",
            rm: "Dhanyavaad",
            en: "Thank you",
        },
        {
            hi: "बहुत धन्यवाद",
            rm: "Bahut dhanyavaad",
            en: "Thank you very much",
        },
        {
            hi: "शुक्रिया",
            rm: "Shukriya",
            en: "Thank you (informal)",
        },
        {
            hi: "कोई बात नहीं",
            rm: "Koi baat nahi",
            en: "You're welcome / No problem",
        },
        {
            hi: "माफ़ कीजिए",
            rm: "Maaf kijiye",
            en: "Excuse me / I'm sorry",
        },
        {
            hi: "मुझे माफ़ करना",
            rm: "Mujhe maaf karna",
            en: "I'm sorry (more personal)",
        },
        {
            hi: "कृपा करके",
            rm: "Kripa karke",
            en: "Please",
        },
        {
            hi: "हाँ",
            rm: "Haan",
            en: "Yes",
        },
        {
            hi: "नहीं",
            rm: "Nahi",
            en: "No",
        },
        {
            hi: "ठीक है",
            rm: "Theek hai",
            en: "Okay / Alright",
        },
        {
            hi: "मैं नहीं समझता",
            rm: "Main nahi samajhta",
            en: "I don't understand (male)",
        },
        {
            hi: "मैं नहीं समझती",
            rm: "Main nahi samajhti",
            en: "I don't understand (female)",
        },
        {
            hi: "क्या आप अंग्रेजी बोलते हैं?",
            rm: "Kya aap angrezi bolte hain?",
            en: "Do you speak English?",
        },
        {
            hi: "क्या आप समझते हैं?",
            rm: "Kya aap samajhte hain?",
            en: "Do you understand?",
        },
        {
            hi: "यह क्या है?",
            rm: "Yeh kya hai?",
            en: "What is this?",
        },
        {
            hi: "यह कितने का है?",
            rm: "Yeh kitne ka hai?",
            en: "How much is this?",
        },
        {
            hi: "कितना हुआ?",
            rm: "Kitna hua?",
            en: "How much does it cost? (total)",
        },
        {
            hi: "कहाँ है?",
            rm: "Kahan hai?",
            en: "Where is...?",
        },
        {
            hi: "शौचालय कहाँ है?",
            rm: "Shauchalay kahan hai?",
            en: "Where is the toilet?",
        },
        {
            hi: "रेलवे स्टेशन कहाँ है?",
            rm: "Railway station kahan hai?",
            en: "Where is the railway station?",
        },
        {
            hi: "हवाई अड्डा कहाँ है?",
            rm: "Hawai adda kahan hai?",
            en: "Where is the airport?",
        },
        {
            hi: "अस्पताल कहाँ है?",
            rm: "Aspatal kahan hai?",
            en: "Where is the hospital?",
        },
        {
            hi: "मदद करो!",
            rm: "Madad karo!",
            en: "Help!",
        },
        {
            hi: "पुलिस!",
            rm: "Police!",
            en: "Police!",
        },
        {
            hi: "मुझे मदद चाहिए",
            rm: "Mujhe madad chahiye",
            en: "I need help (male/neutral)",
        },
        {
            hi: "मुझे मदद चाहिए",
            rm: "Mujhe madad chahiye",
            en: "I need help (female)",
        },
        {
            hi: "मैं खो गया हूँ",
            rm: "Main kho gaya hoon",
            en: "I am lost (male)",
        },
        {
            hi: "मैं खो गई हूँ",
            rm: "Main kho gayi hoon",
            en: "I am lost (female)",
        },
        {
            hi: "क्या आप मेरी मदद कर सकते हैं?",
            rm: "Kya aap meri madad kar sakte hain?",
            en: "Can you help me?",
        },
        {
            hi: "धीरे बोलिए",
            rm: "Dheere boliye",
            en: "Speak slowly",
        },
        {
            hi: "फिर से बोलिए",
            rm: "Phir se boliye",
            en: "Say it again",
        },
        {
            hi: "मैं बीमार हूँ",
            rm: "Main bimaar hoon",
            en: "I am sick (male)",
        },
        {
            hi: "मैं बीमार हूँ",
            rm: "Main bimaar hoon",
            en: "I am sick (female)",
        },
        {
            hi: "मुझे डॉक्टर चाहिए",
            rm: "Mujhe doctor chahiye",
            en: "I need a doctor (male/neutral)",
        },
        {
            hi: "मुझे डॉक्टर चाहिए",
            rm: "Mujhe doctor chahiye",
            en: "I need a doctor (female)",
        },
        {
            hi: "यह बहुत महंगा है",
            rm: "Yeh bahut mehanga hai",
            en: "This is too expensive",
        },
        {
            hi: "क्या आप कम कर सकते हैं?",
            rm: "Kya aap kam kar sakte hain?",
            en: "Can you lower the price?",
        },
        {
            hi: "मुझे यह चाहिए",
            rm: "Mujhe yeh chahiye",
            en: "I want this (male/neutral)",
        },
        {
            hi: "मुझे यह चाहिए",
            rm: "Mujhe yeh chahiye",
            en: "I want this (female)",
        },
        {
            hi: "मुझे यह नहीं चाहिए",
            rm: "Mujhe yeh nahi chahiye",
            en: "I don't want this (male/neutral)",
        },
        {
            hi: "मुझे यह नहीं चाहिए",
            rm: "Mujhe yeh nahi chahiye",
            en: "I don't want this (female)",
        },
        {
            hi: "मेरा नाम... है",
            rm: "Mera naam... hai",
            en: "My name is...",
        },
        {
            hi: "आप कैसे हैं?",
            rm: "Aap kaise hain?",
            en: "How are you? (formal)",
        },
        {
            hi: "आप कैसी हैं?",
            rm: "Aap kaisi hain?",
            en: "How are you? (formal, to a female)",
        },
        {
            hi: "क्या हाल है?",
            rm: "Kya haal hai?",
            en: "How are you? (informal)",
        },
        {
            hi: "मैं ठीक हूँ",
            rm: "Main theek hoon",
            en: "I am fine (male)",
        },
        {
            hi: "मैं ठीक हूँ",
            rm: "Main theek hoon",
            en: "I am fine (female)",
        },
        {
            hi: "अच्छा",
            rm: "Achha",
            en: "Good / Okay",
        },
        {
            hi: "बहुत अच्छा",
            rm: "Bahut achha",
            en: "Very good",
        },
        {
            hi: "बुरा",
            rm: "Bura",
            en: "Bad",
        },
        {
            hi: "शुभ प्रभात",
            rm: "Shubh Prabhat",
            en: "Good morning",
        },
        {
            hi: "शुभ दोपहर",
            rm: "Shubh dopahar",
            en: "Good afternoon",
        },
        {
            hi: "शुभ संध्या",
            rm: "Shubh sandhya",
            en: "Good evening",
        },
        {
            hi: "शुभ रात्रि",
            rm: "Shubh ratri",
            en: "Good night",
        },
        {
            hi: "अलविदा",
            rm: "Alvida",
            en: "Goodbye",
        },
        {
            hi: "फिर मिलेंगे",
            rm: "Phir milenge",
            en: "See you again",
        },
        {
            hi: "बाद में मिलेंगे",
            rm: "Baad mein milenge",
            en: "See you later",
        },
        {
            hi: "दाहिने",
            rm: "Dahine",
            en: "Right",
        },
        {
            hi: "बाएं",
            rm: "Baaye",
            en: "Left",
        },
        {
            hi: "सीधे",
            rm: "Seedhe",
            en: "Straight",
        },
        {
            hi: "ऊपर",
            rm: "Upar",
            en: "Up",
        },
        {
            hi: "नीचे",
            rm: "Neeche",
            en: "Down",
        },
        {
            hi: "पास",
            rm: "Paas",
            en: "Near",
        },
        {
            hi: "दूर",
            rm: "Door",
            en: "Far",
        },
        {
            hi: "आज",
            rm: "Aaj",
            en: "Today",
        },
        {
            hi: "कल",
            rm: "Kal",
            en: "Tomorrow / Yesterday (context matters)",
        },
        {
            hi: "अभी",
            rm: "Abhi",
            en: "Now",
        },
        {
            hi: "बाद में",
            rm: "Baad mein",
            en: "Later",
        },
        {
            hi: "सुबह",
            rm: "Subah",
            en: "Morning",
        },
        {
            hi: "दोपहर",
            rm: "Dopahar",
            en: "Afternoon",
        },
        {
            hi: "शाम",
            rm: "Shaam",
            en: "Evening",
        },
        {
            hi: "रात",
            rm: "Raat",
            en: "Night",
        },
        {
            hi: "पानी",
            rm: "Paani",
            en: "Water",
        },
        {
            hi: "खाना",
            rm: "Khana",
            en: "Food",
        },
        {
            hi: "चाय",
            rm: "Chai",
            en: "Tea",
        },
        {
            hi: "कॉफ़ी",
            rm: "Coffee",
            en: "Coffee",
        },
        {
            hi: "बियर",
            rm: "Beer",
            en: "Beer",
        },
        {
            hi: "शराब",
            rm: "Sharab",
            en: "Alcohol/Liquor",
        },
        {
            hi: "शाकाहारी",
            rm: "Shakahari",
            en: "Vegetarian",
        },
        {
            hi: "मांसाहारी",
            rm: "Mansahari",
            en: "Non-vegetarian",
        },
        {
            hi: "यह शाकाहारी है?",
            rm: "Yeh shakahari hai?",
            en: "Is this vegetarian?",
        },
        {
            hi: "मुझे भूख लगी है",
            rm: "Mujhe bhookh lagi hai",
            en: "I am hungry (male/female)",
        },
        {
            hi: "मुझे प्यास लगी है",
            rm: "Mujhe pyaas lagi hai",
            en: "I am thirsty (male/female)",
        },
        {
            hi: "कितना समय लगेगा?",
            rm: "Kitna samay lagega?",
            en: "How much time will it take?",
        },
        {
            hi: "पासपोर्ट",
            rm: "Passport",
            en: "Passport",
        },
        {
            hi: "वीज़ा",
            rm: "Visa",
            en: "Visa",
        },
        {
            hi: "टिकट",
            rm: "Ticket",
            en: "Ticket",
        },
        {
            hi: "होटल",
            rm: "Hotel",
            en: "Hotel",
        },
        {
            hi: "कमरा",
            rm: "Kamra",
            en: "Room",
        },
        {
            hi: "मैं एक कमरा बुक करना चाहता हूँ",
            rm: "Main ek kamra book karna chahta hoon",
            en: "I want to book a room (male)",
        },
        {
            hi: "मैं एक कमरा बुक करना चाहती हूँ",
            rm: "Main ek kamra book karna chahti hoon",
            en: "I want to book a room (female)",
        },
        {
            hi: "यह बहुत अच्छा है",
            rm: "Yeh bahut achha hai",
            en: "This is very good",
        },
        {
            hi: "यह बहुत बुरा है",
            rm: "Yeh bahut bura hai",
            en: "This is very bad",
        },
        {
            hi: "कोई दिक्कत नहीं",
            rm: "Koi dikkat nahi",
            en: "No problem",
        },
        {
            hi: "शुभकामनाएँ",
            rm: "Shubhkamnaayein",
            en: "Best wishes",
        },
        {
            hi: "मज़े करो",
            rm: "Maze karo",
            en: "Have fun",
        },
    ]
};
